module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/download_primary.4f032ac4490597140fc616ca18480d7e.svg";